/** @file attachmentIndexOf: the attachment index of a flattened `att<i>.` drawable or node id. */

const CHAR_0 = 48;
const CHAR_9 = 57;
const CHAR_DOT = 46;

/** `i` of an id `att<i>.<rest>` (ASCII digits, flattening's prefix, 17.8), else -1; allocates nothing. */
export function attachmentIndexOf(id: string): number {
  if (!id.startsWith('att')) return -1;
  let i = 3;
  let n = 0;
  for (; i < id.length; i++) {
    const c = id.charCodeAt(i);
    if (c < CHAR_0 || c > CHAR_9) break;
    n = n * 10 + (c - CHAR_0);
  }
  return i > 3 && i < id.length && id.charCodeAt(i) === CHAR_DOT ? n : -1;
}
